export default class Map_DynamicElementMaterial {
  color;
  alpha;
  size;
  events;

  constructor(events) {
    this.color = "#FFFFFF";
    this.alpha = 0.8;
    this.size = 35;
    this.events = events;
  }

  setColor(color) {
    let regex = /^#[0-9A-F]{6}$/i;
    if(! regex.test(color)) {
      color = decodeURIComponent(color);
    }

    if(! regex.test(color)) {
      color = "#FFFFFF";
    }

    this.color = color;
  }

  setAlpha(alpha) {
    this.alpha = alpha;
  }

  setSize(size) {
    if (!this.isNumber(size)) {
      return;
    }
    this.size = Number.parseFloat(size);
  }

  getSize() {
    return this.size;
  }

  getColor() {
    return new Cesium.CallbackProperty(() => {
      if (
        (
          this.events.isInsert() == false &&
          this.events.isPicked() == true &&
          this.events.isControlPointClickLeft() == false
        ) ||
        this.events.isBorderHover()
      ) {
        return Cesium.Color.YELLOW.withAlpha(this.alpha / 2);
      } else {
        return Cesium.Color.fromCssColorString(this.color).withAlpha(this.alpha);
      }
    }, false);
  }

  getPolyMaterial() {
    let material = new Cesium.ColorMaterialProperty(this.getColor());
    return material;
  }

  getPolylineMaterial() {
    let material = new Cesium.PolylineOutlineMaterialProperty({
      color: Cesium.Color.fromCssColorString(this.color),
      outlineWidth: 1,
      outlineColor: Cesium.Color.fromCssColorString(this.color),
    });
    return material;
  }

  getLineMaterial() {
    let material = new Cesium.PolylineDashMaterialProperty({
      color: this.getColor(),
    });
    return material;
  }

  getSvgPoint() {
    let width = this.size;
    let height = this.size * 1.7;

    const svg2 = `<svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.52 169.9">
      <path d="M43.54,10.63L0,84.95l16.33,27.87,33.43,57.07,21.39-36.51,28.38-48.44-6.22-10.62L55.98,10.62,49.76,0l-6.22,10.63ZM74.64,84.95l-24.88,42.47-24.88-42.47,24.88-42.47,24.88,42.47Z" style="fill:#fff;"/>
    </svg>`;

    return svg2;
  }

  getSvgCircle() {
    let svg = `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 10 10">`;
    svg += `<circle fill="#ffffff" fill-opacity="0.8" stroke-width="0.2" stroke="#d7d7d7" cx="5" cy="5" r="5" />`;
    svg += `</svg>`;
    return `data:image/svg+xml;base64,` + btoa(svg);
  }

  isNumber(value) {
    return /^-?\d+(\.\d+)?$/.test(value);
  }
}
